import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getClaimOriginOptions } from '../api/claimOriginApi';

type QueryFnType = typeof getClaimOriginOptions;

type UseClaimOriginsSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useClaimOriginsSelect = ({ config = {} }: UseClaimOriginsSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['useClaimOriginsSelect', i18n.language],
        queryFn: () => getClaimOriginOptions(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};